"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.publicFeedbackContract = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const utils_1 = require("../utils");
const models_1 = require("./models");
const c = (0, core_1.initContract)();
exports.publicFeedbackContract = c.router({
    sendFeedback: {
        method: 'POST',
        path: '/feedback',
        body: models_1.ZFeedbackInsert.pick({
            action: true,
            feedback: true,
            playerId: true,
            refId: true,
        }),
        responses: {
            200: utils_1.successSchema,
            400: zod_1.z.object({
                message: zod_1.z.string(),
            }),
        },
    },
}, {
    pathPrefix: '/public',
});
//# sourceMappingURL=feedback.public.contract.js.map